import {DateRangeFieldValue} from 'features/GlobalFilterProvider/filters/period/DateRangeItem/types';
import {PeriodType} from 'modules/decisionsNext/api/types';

import {formatPolicyFilterPeriod} from 'features/GlobalFilterProvider/utils/formatters';

export const formatDateRangeValue = (value: DateRangeFieldValue): DateRangeFieldValue => {
  const formatted = formatPolicyFilterPeriod(value);

  return {
    ...formatted,
    inForceToday: formatted.type === PeriodType.InForce && !value.timestamp,
  } as DateRangeFieldValue;
};
